import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import wordmark_black from '../images/wordmark_black.png';
import wordmark_white from '../images/wordmark_white.png';

//Data Types
type Props = { location: any };
//Styled Components
const HeaderItem =
	styled('div') <
	{ color: string } >
	`
  color: ${(props) => `#${props.color}`};
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 25px;
  text-align: center;
  min-height: 55px;
  max-width: 175px;
`;
const ConnectButton =
	styled('button') <
	{ mobile: boolean } >
	`
	border: ${(props) => `${props.mobile ? '3px solid white' : '3px solid #ff2b54'}`};
	font-weight: bold;
  border-radius: 7px;
  padding: 4px 0;
  color: ${(props) => `${props.mobile ? 'white' : '#ff254b'}`};
  min-width: 145px;
  transition: 0.3s ease-in-out;
  background: ${(props) => `${props.mobile ? 'transparent' : 'white'}`};
	cursor: pointer;
	font-size: 16px;
  :hover {
    color: ${(props) => `${props.mobile ? '#313131' : 'white'}`};
    background-color: ${(props) => `${props.mobile ? 'white' : '#ff254b'}`};
  }
  :focus {
    outline: 0;
  }
`;
const MobileWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	@media screen and (min-width: 768px) and (max-width: 880px) {
		display: none;
	}
`;
//Component
const Header: React.SFC<Props> = ({ location }) => {
	let mql;
	const [ scrolled, setScrolled ] = useState(false);
	const [ open, setOpen ] = useState(false);
	const [ mobile, setMobile ] = useState(false);
	const [ caseStudy, setCaseStudy ] = useState(false);
	const [ blog, setBlog ] = useState(false);
	useEffect(() => {
		if (typeof window !== undefined) {
			mql = window.matchMedia(`(min-width: 768px)`);
			mql.addListener(mediaQueryChanged);
			mediaQueryChanged();
		}
		return () => {
			if (typeof window !== undefined) {
				mql.removeListener(mediaQueryChanged);
			}
		};
	}, []);
	useEffect(() => {
		if (typeof window !== undefined) {
			window.addEventListener('scroll', handleScroll);
		}
		return () => {
			if (typeof window !== undefined) {
				window.removeEventListener('scroll', handleScroll);
			}
		};
	}, []);
	useEffect(() => {
		if ((location.pathname as string).includes('/portfolio/') && (location.pathname as string).length > 11) {
			setCaseStudy(true);
		} else if ((location.pathname as string).includes('/blog/') && (location.pathname as string).length > 6) {
			setBlog(true);
		}
	}, []);
	const handleScroll = () => {
		if (typeof window !== 'undefined') {
			if (window.scrollY < 30) {
				setScrolled(false);
			} else {
				setScrolled(true);
			}
		}
	};
	const mediaQueryChanged = () => {
		if (mql.matches) {
			setMobile(false);
			setOpen(false);
		} else {
			setMobile(true);
		}
	};
	const toggle = () => {
		setOpen(!open);
	};
	return (
		<nav
			id='header'
			style={
				scrolled || open || caseStudy || blog ? (
					{
						background: 'white',
						boxShadow: '0 4px 23px 0 rgba(219,229,236,.6)',
						borderColor: 'rgba(34,34,34,.05)'
					}
				) : (
					{
						background: 'transparent'
					}
				)
			}
			className={`navbar is-transparent is-fixed-top top-menu`}
		>
			<span className={`${mobile ? 'menu-secret' : ''} ${open ? 'open' : ''}`} />
			<div style={{ height: '100%' }} className='navbar-brand'>
				<Link title={'Home'} to={'/'} className='logo-link'>
					<img
						alt='Lattice Studios'
						style={{ height: '40px' }}
						src={open ? wordmark_white : scrolled || caseStudy || blog ? wordmark_black : wordmark_white}
					/>
				</Link>
				<div
					className={open ? 'navbar-burger is-active no-hover' : 'navbar-burger no-hover'}
					data-target='navMenu'
					onClick={() => {
						toggle();
					}}
				>
					<span style={{ height: '2px' }} />
					<span style={{ height: '2px' }} />
					<span style={{ height: '2px' }} />
				</div>
			</div>

			<div
				id='navMenu'
				style={{
					boxShadow: open ? 'none' : undefined,
					height: open ? '100vh' : undefined,
					paddingTop: 0,
					backgroundColor: 'transparent'
				}}
				className={`${open ? 'navbar-menu is-active' : 'navbar-menu'} dropdown`}
			>
				<div className='navbar-start' />
				<div
					style={{
						height: mobile ? 'calc(100% - 64px)' : undefined,
						display: mobile ? 'flex' : undefined,
						flexDirection: mobile ? 'column' : undefined,
						justifyContent: mobile ? 'center' : undefined,
						alignItems: mobile ? 'center' : undefined
					}}
					className='navbar-end navbar-end-transition'
				>
					{!mobile ? (
						<React.Fragment>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'About'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/about'}
								>
									About
								</Link>
							</HeaderItem>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'Portfolio'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/portfolio'}
								>
									Portfolio
								</Link>
							</HeaderItem>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'Process'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/process'}
								>
									Process
								</Link>
							</HeaderItem>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'Services'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/services'}
								>
									Services
								</Link>
							</HeaderItem>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'Pricing'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/pricing'}
								>
									Pricing
								</Link>
							</HeaderItem>
							<MobileWrapper>
								<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
									<Link
										title={'Blog'}
										style={{ color: open && mobile ? '#fff' : '#474747' }}
										to={'/blog'}
									>
										Blog
									</Link>
								</HeaderItem>
							</MobileWrapper>

							<HeaderItem color={open && mobile ? '#fff' : '#474747'} className='navbar-item'>
								<Link to={'/connect'}>
									<ConnectButton mobile={mobile}>Connect</ConnectButton>
								</Link>
							</HeaderItem>
						</React.Fragment>
					) : (
						<div>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'About'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/about'}
								>
									About
								</Link>
							</HeaderItem>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'Portfolio'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/portfolio'}
								>
									Portfolio
								</Link>
							</HeaderItem>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'Process'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/process'}
								>
									Process
								</Link>
							</HeaderItem>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'Services'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/services'}
								>
									Services
								</Link>
							</HeaderItem>
							<HeaderItem color={open && mobile ? 'fff' : '474747'} className='navbar-item'>
								<Link
									title={'Pricing'}
									style={{ color: open && mobile ? '#fff' : '#474747' }}
									to={'/pricing'}
								>
									Pricing
								</Link>
							</HeaderItem>
							<MobileWrapper className='navbar-item'>
								<HeaderItem color={open && mobile ? 'fff' : '474747'}>
									<Link
										title={'Blog'}
										style={{ color: open && mobile ? '#fff' : '#474747' }}
										to={'/blog'}
									>
										Blog
									</Link>
								</HeaderItem>
							</MobileWrapper>
							<HeaderItem color={open && mobile ? '#fff' : '#474747'} className='navbar-item'>
								<Link title={'Connect'} to={'/connect'}>
									<ConnectButton mobile={mobile}>Connect</ConnectButton>
								</Link>
							</HeaderItem>
						</div>
					)}
				</div>
			</div>
		</nav>
	);
};

export default Header;
